import $ from 'jquery';
import _ from 'underscore';
import { DeliveryStatusPopupFactory } from '@bingads-webui-campaign/delivery-status-popup-factory';
import { RECOMMENDATION_TYPES, CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';

import template from './contextual-attribute.pug';

import { SharedBudgetContextualAttributeViewVNext } from './sharedBudgetVNext';
import { AccountContextualAttributeView } from './accountVNext';
import { CampaignContextualAttributeViewVNext } from './campaignVNext';
import { AdGroupContextualAttributeViewVNext } from './adgroupVNext';
import { KeywordContextualAttributeViewVNext } from './keywordVNext';
import { AudienceContextualAttributeViewVNext } from './audienceVNext';
import { NegativeKeywordListContextualAttributeViewVNext } from './negativeKeywordListVNext';
import { GoalContextualAttributeView } from './goal';
import { CurrentSettingContextualAttributeView } from './currentSetting';
import { SuggestedSettingContextualAttributeView } from './suggestedSetting';
import { GeneratedFromContextualAttributeView } from './generatedFrom';
import { MoreImagesContextualAttributeView } from './moreImages';
import { MoreConversionClarityButtonsContextualAttributeView } from './moreConversionClarityButtons';
import { ImportTaskItemContextualAttributeView } from './importTaskItem';
import { CampaignsContextualAttributeView } from './campaigns';

export const withContextualAttributeTemplate = ({
  opportunityId,
  entityName,
  entityId,
  entityType,
  entityCampaignId,
  status,
  isExpandingView,
  ariaLabel = '',
  accountName,
  pageUrls,
}) => template({
  opportunityId,
  entityName,
  entityId,
  entityType,
  entityCampaignId,
  status,
  isExpandingView,
  ariaLabel,
  accountName,
  pageUrls,
});

function showDeliveryStatusPopup(e, self, contextualAttributeViewTemplate) {
  const factory = new DeliveryStatusPopupFactory({ grid: self.grid, i18n: self.i18n });
  factory.showRejectionPopup({
    event: e,
    getCustomTemplate: () => contextualAttributeViewTemplate,
    isContextualAttributeForRecommendation: true,
    popoverId: 'contextual-attribute',
    view: self,
  });
}

export const showContextualAttribute = ({
  deps,
  i18n,
  e,
  type,
  isMCC = false,
  isExpanding = false,
  self,
  scope,
  recommendationService,
  s$i18n,
  newI18n,
}) => {
  if (!deps.edmCampaign) {
    _.extend(deps, { edmCampaign });
  }
  const target = $(e.target);
  const elMapper = {
    [RECOMMENDATION_TYPES.REPAIR_ADS]: '.recommendation-repair-ads-inline-view',
    [RECOMMENDATION_TYPES.REPAIR_KEYWORD]: '.recommendation-repair-keywords-inline-view',
    [RECOMMENDATION_TYPES.CALLOUT]: '.recommendation-inline-ad-extension-view',
    [RECOMMENDATION_TYPES.SITE_LINK]: '.recommendation-inline-ad-extension-view',
    [RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]: '.recommendation-inline-budget-view',
    [RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY]: '.recommendation-inline-budget-view',
    [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: '.recommendation-new-ads-inline-view',
    [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: '.recommendation-new-ads-inline-view',
    [RECOMMENDATION_TYPES.REALLOCATE_BUDGET]: '.recommendation-reallocate-budget',
    [RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS]: '.recommendation-dynamic-search-ads-inline-view',
    [RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY]: '.recommendation-setup-conversion-tracking',
    [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: '.recommendation-inline-fix-conversion-goal-setting-view',
  };

  const contextualAttributeMapper = {
    [CONTEXTUAL_ENTITY_TYPE.CAMPAIGN]:
       CampaignContextualAttributeViewVNext,
    [CONTEXTUAL_ENTITY_TYPE.ADGROUP]:
       AdGroupContextualAttributeViewVNext,
    [CONTEXTUAL_ENTITY_TYPE.KEYWORD]: KeywordContextualAttributeViewVNext,
    [CONTEXTUAL_ENTITY_TYPE.AUDIENCE]: AudienceContextualAttributeViewVNext,
    [CONTEXTUAL_ENTITY_TYPE.NEGATIVE_KEYWORD_LIST]: NegativeKeywordListContextualAttributeViewVNext,
    [CONTEXTUAL_ENTITY_TYPE.SHARED_BUDGET]:
       SharedBudgetContextualAttributeViewVNext,
    [CONTEXTUAL_ENTITY_TYPE.ACCOUNT]: AccountContextualAttributeView,
    [CONTEXTUAL_ENTITY_TYPE.GOAL]: GoalContextualAttributeView,
    [CONTEXTUAL_ENTITY_TYPE.CURRENT_SETTING]: CurrentSettingContextualAttributeView,
    [CONTEXTUAL_ENTITY_TYPE.SUGGESTED_SETTING]: SuggestedSettingContextualAttributeView,
    [CONTEXTUAL_ENTITY_TYPE.GENERATED_FROM]: GeneratedFromContextualAttributeView,
    [CONTEXTUAL_ENTITY_TYPE.MORE_IMAGES]: MoreImagesContextualAttributeView,
    [CONTEXTUAL_ENTITY_TYPE.MORE_CONVERSION_CLARITY_BUTTONS]: MoreConversionClarityButtonsContextualAttributeView,
    [CONTEXTUAL_ENTITY_TYPE.IMPORTED_TASK_ITEM]: ImportTaskItemContextualAttributeView,
    [CONTEXTUAL_ENTITY_TYPE.CAMPAIGNS]: CampaignsContextualAttributeView,
  };

  const contextual = isExpanding ? $(`${elMapper[type]} .expanding-contextual-attribute-${target.data('opportunityid')}-${target.data('entityid')}`) // eslint-disable-line
    : $(`.contextual-attribute-${target.data('opportunityid')}-${target.data('entityid')}`);

  if (contextual.length === 0) {
    return;
  }

  if (!target.data('status')) {
    const key = $(e.target).parents('tr[data-key]').data('key') || $(e.target).parents('tr[key]').attr('key');
    const recommendation = self.grid.gridView.itemWithKey(key) || self.data; // self.data for panelEdit
    const recommendationAccountId = recommendation.Target.AccountId;
    const contextualAttributeView = new contextualAttributeMapper[target.data('type')]({
      deps,
      i18n,
      isMCC,
      targetId: Number(target.data('entityid')),
      el: contextual,
      scope,
      accountName: target.data('accountname'),
      pageUrls: target.data('pageurls'),
      recommendationService,
      s$i18n,
      newI18n,
      images: _.result(_.first(recommendation.Opportunities), 'Images'),
      key,
      gridView: self.grid.gridView,
      conversionClarityButtons: _.result(_.result(_.first(recommendation.Opportunities), 'SuggestedClarityEventGoal'), 'ConversionClarityButtons'),
      budgetAdjustmentOption: _.result(_.first(recommendation.Opportunities), 'BudgetAdjustmentOption'),
      taskItemId: _.result(_.first(recommendation.Opportunities), 'RuleId'),
    });
    contextualAttributeView.render({
      showDeliveryStatusPopup: _.partial(showDeliveryStatusPopup, e, self),
      recommendationAccountId,
    });
    target.data('status', 'true');
  }

  if (contextual.children('.contextual-tooltip-container').length > 0) { // new ui
    showDeliveryStatusPopup(
      e,
      self,
      contextual.children('.contextual-tooltip-container')[0].outerHTML
    );
  } else { // old ui
    $(`.expanding-contextual-attribute-${target.data('opportunityid')}-${target.data('entityid')}`).show();
  }
};

export const hideContextualAttribute = ({
  e,
  self,
}) => {
  if ($(e.relatedTarget).closest('#contextual-attribute').length === 0) {
    self.trigger('closeDeliveryStatusPopup');
  }
};
